import { render } from "./EducationSection.vue?vue&type=template&id=4ac71edc&lang=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__